import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from '../../ui/scroll-area';
import { CopyButton } from './copy-button';
export const HighlightedCodeBlock = ({ highlightedCode, code, title, showLineNumbers, }) => {
    const lines = code.trim().split(/\r\n|\r|\n/);
    const attrs = {
        'data-show-line-nubmers': showLineNumbers ? '' : undefined,
        'data-has-title': title ? '' : undefined,
    };
    return (_jsxs("div", { ...attrs, className: "code-block", children: [title && (_jsxs("div", { className: "header", children: [_jsx("div", { className: "title", children: title }), _jsx(CopyButton, { content: code })] })), _jsxs("div", { className: "body", children: [code && showLineNumbers && (_jsx("div", { className: "line-numbers", children: Array(lines.length)
                            .fill(0)
                            .map((_, i) => (_jsx("div", { className: "line-number", children: i + 1 }, i))) })), _jsx(ScrollArea, { children: _jsx("div", { className: "code-container", dangerouslySetInnerHTML: { __html: highlightedCode } }) }), !title && _jsx(CopyButton, { content: code })] })] }));
};
